import { defineComponent as Ie, ref as y, computed as d, watch as B, openBlock as h, createBlock as re, unref as K, withCtx as xe, withDirectives as x, createElementBlock as I, normalizeClass as C, createElementVNode as u, createCommentVNode as U, vShow as V, withKeys as Ce, vModelText as be, toDisplayString as j, Fragment as R, renderList as q } from "vue";
import { R as Te } from "./Resolutions.98ea1054.js";
import { OnClickOutside as ke } from "@vueuse/components";
import { B as Se } from "./BodyScrollLock.945be9eb.js";
import { i as Fe } from "./Numbers.0dd1fb08.js";
import { ValidationMessage as Le } from "../validationMessage.es.js";
import '../assets/index25.css';function Ve(n, a, t = 3) {
  if (a.length < t)
    return n;
  const _ = new RegExp(`(${a})`, "gi");
  return n.replace(_, "<mark>$1</mark>");
}
const Me = (n) => {
  n.style.top = "", n.style.bottom = "", n.style.left = "", n.style.right = "";
}, Oe = (n, a) => {
  const t = n.getBoundingClientRect().top, _ = n.offsetHeight, A = 10, f = a.modifiers.offsetBottom && Fe(n.getAttribute("offsetBottom")) ? parseFloat(n.getAttribute("offsetBottom") + "") : 0;
  return t + f + _ + A > window.innerHeight;
}, Ee = (n) => {
  const a = n.getBoundingClientRect().left, t = n.offsetWidth, _ = 20;
  return a + t + _ > window.innerWidth;
}, Ge = (n) => {
  if (typeof n.value != "boolean")
    throw new Error(
      "The binding of check-position directive must be a boolean value."
    );
}, He = {
  mounted(n, a) {
    Ge(a);
  },
  updated(n, a) {
    a.oldValue !== a.value && a.value === !0 && (Me(n), Oe(n, a) && (n.style.top = "auto", n.style.bottom = "100%"), Ee(n) && (n.style.left = "auto", n.style.right = "0"));
  }
};
function P(n, a, t) {
  let _ = "";
  return n && typeof n == "object" && a.length > 0 ? _ = n[a] : _ = n, Be(_, t);
}
function Be(n, a) {
  return a.indexOf("{0}") > -1 ? a.replace("{0}", n) : n;
}
var w = /* @__PURE__ */ ((n) => (n.ForceReset = "ForceReset", n.Reset = "Reset", n.SelectedIndex = "SelectedIndexChanged", n.SelectedValue = "SelectedValueChanged", n.SelectItem = "SelectItem", n))(w || {});
const Re = ["innerHTML"], Pe = ["innerHTML"], Ae = ["innerHTML", "data-event"], Ne = { class: "DropDown__search" }, $e = ["disabled", "placeholder", "onKeyup"], We = { class: "DropDown__search__icon DropDown__search__icon--spinner" }, Ke = ["innerHTML", "data-event"], Ue = ["onClick", "innerHTML", "data-index", "data-event"], je = { class: "DropDown__dividerGroup" }, qe = /* @__PURE__ */ u("div", { class: "DropDown__dividerGroup__line" }, null, -1), ze = { class: "DropDown__dividerGroup__group" }, Je = /* @__PURE__ */ u("div", { class: "DropDown__dividerGroup__line" }, null, -1), Qe = ["onClick", "innerHTML", "data-index", "data-event"], Xe = 32, Ye = 42, Ze = 8, at = /* @__PURE__ */ Ie({
  __name: "DropDown",
  props: {
    title: { default: "" },
    placeholder: { default: "Search..." },
    emptyOption: { default: "" },
    allowFilterOptions: { type: Boolean, default: !1 },
    allowAutoFilter: { type: Boolean, default: !0 },
    items: { default: () => [] },
    selectedIndex: { default: -1 },
    selectedValue: { default: "" },
    textStringFormat: { default: "{0}" },
    isDisabled: { type: Boolean, default: !1 },
    isReadonly: { type: Boolean, default: !1 },
    forceReset: { type: Boolean, default: !1 },
    searchFunc: {},
    notFoundMessage: { default: "No matches to your query could be found. Try another search term." },
    validationErrorMessage: {},
    dataText: { default: "" },
    separators: { default: () => [] },
    useGroups: { type: Boolean, default: !1 }
  },
  emits: ["selected-item"],
  setup(n, { emit: a }) {
    const t = n, _ = Se, A = He, f = y(null), c = y(0), g = y(!1), T = y(!1), v = y(""), E = y(!1), k = y(""), z = y(!1), D = y(-1), r = y(null), ue = d(() => {
      const e = ["DropDown__titleContainer"];
      return N.value && e.push("is-filtered"), g.value && e.push("DropDown__titleContainer--active"), r.value && e.push("DropDown__titleContainer--hasValue"), e;
    }), ie = d(() => {
      const e = ["DropDown__overlay"];
      return g.value === !1 && e.push("is-hidden"), e;
    }), ce = d(() => {
      const e = ["DropDown__menuWrapper"];
      return g.value && e.push("DropDown__menuWrapper--open"), J.value && e.push("DropDown__menuWrapper--no-items"), e;
    }), de = d(() => T.value === !1 && J.value === !1), G = d(() => t.emptyOption !== null && t.emptyOption.trim().length > 0 ? t.allowAutoFilter === !0 ? v.value.trim().length === 0 : k.value.length === 0 && t.items.length > 0 : !1), H = d(() => typeof t.searchFunc == "function" && t.allowAutoFilter === !1), fe = d(() => v.value.trim().length === 0 || k.value.trim().length > 0 ? !1 : H.value ? z.value && t.items.length === 0 : p.value.length === 0), N = d(() => r.value !== null), ve = d(() => g.value && !Te.isDesktop()), J = d(() => H.value ? t.items.length === 0 : p.value.length === 0), pe = d(() => {
      const e = ["DropDown"];
      return t.isDisabled && e.push("is-disabled"), t.isReadonly && e.push("is-readonly"), Q.value && e.push("is-filter-error"), e;
    }), me = d(() => {
      const e = ["DropDown__option"];
      return N.value || e.push("DropDown__option--active"), c.value === -1 && e.push("DropDown__option--arrow-active"), e;
    }), p = d(() => {
      if (t.allowAutoFilter === !0 && v.value) {
        const e = v.value.toLowerCase();
        if (c.value = 0, t.useGroups) {
          const l = [];
          for (let o = 0; o < t.items.length; o += 1) {
            const s = t.items[o], m = s.items.filter(
              (i) => L(i).toLowerCase().indexOf(e) > -1
            );
            if (m.length > 0) {
              const i = l.length - 1;
              let b = 0, ae = 0;
              i > 0 && l.length > 0 && (b = l[i].items.length, ae = l[i].totalPreviousItems), l.push({
                name: s.name,
                items: m,
                totalPreviousItems: b + ae
              });
            }
          }
          return l;
        } else
          return t.items.filter(
            (l) => L(l).toLowerCase().indexOf(e) > -1
          );
      }
      return t.items;
    }), M = d(() => {
      if (t.useGroups) {
        let e = 0;
        for (let l = 0; l < p.value.length; l += 1) {
          const o = p.value[l];
          e += o.items.length;
        }
        return e;
      } else
        return p.value.length;
    });
    d(() => v.value.length > 0);
    const Q = d(() => t.validationErrorMessage ? t.validationErrorMessage.length > 0 : !1), $ = () => {
      if (!isNaN(t.selectedIndex) && t.selectedIndex > -1) {
        console.warn(
          "selectedIndex and selectedValue cannot be used at the same time"
        );
        return;
      }
      let e = t.items;
      t.useGroups && (e = e.reduce((o, s) => o.concat(s.items), []));
      const l = e.findIndex((o) => {
        let s = L(o);
        return s = s ? s.toLowerCase() : "", t.selectedValue.toLowerCase() === s;
      });
      l !== D.value && (l < 0 ? F(!0, !0, w.SelectedValue) : M.value > t.selectedIndex && (t.useGroups === !0 ? W(
        l,
        !0,
        w.SelectedValue
      ) : oe(
        l,
        w.SelectedValue
      )));
    }, X = () => {
      if (t.allowAutoFilter === !1) {
        if (typeof t.searchFunc != "function")
          throw new Error(
            "If allowAutoFilter is set to false, the searchFunc property must be a function"
          );
        T.value = !0, k.value = "", r.value = null, t.searchFunc(v.value).catch((e) => {
          k.value = e || "Something went wrong";
        }).finally(() => {
          T.value = !1, z.value = !0;
        });
      }
    }, he = () => {
      if (t.isDisabled === !1 && (g.value = !g.value), H.value || (v.value = ""), g.value) {
        const e = t.dataText && r.value ? P(
          r.value,
          t.dataText,
          t.textStringFormat
        ) : r.value;
        if (t.useGroups) {
          const l = p.value.reduce(
            (o, s) => o.concat(s.items),
            []
          );
          D.value = l.findIndex(
            (o) => t.dataText && r.value ? P(o, t.dataText, t.textStringFormat) === e : o === e
          );
        } else
          D.value = p.value.findIndex(
            (l) => t.dataText && r.value ? P(l, t.dataText, t.textStringFormat) === e : l === e
          );
        c.value = D.value, se();
      }
      Y();
    }, S = () => {
      if (g.value = !1, H.value || (v.value = ""), Y(), N.value) {
        let e = 0;
        for (e = 0; e < t.items.length && t.items[e] !== r.value; e += 1)
          ;
      }
      f.value && (f.value.scrollTop = 0);
    }, O = (e, l, o = w.SelectItem) => {
      t.isDisabled === !1 && !ee(l) ? (D.value = l, c.value = l, r.value = e, S(), a("selected-item", e, l, o)) : (D.value = l, r.value = t.items[l], a("selected-item", r.value, l, o));
    }, _e = () => {
      F(!0, !0, w.Reset);
    }, F = (e = !0, l = !0, o = w.Reset) => {
      c.value = G.value ? 0 : -1, D.value > -1 && (D.value = -1, r.value = null, l && a("selected-item", null, -1, o)), e && S();
    }, Y = () => {
      window !== void 0 && (g.value === !0 ? window.addEventListener("keydown", Z) : window.removeEventListener("keydown", Z));
    }, Z = (e) => {
      const l = G.value ? -1 : 0;
      if (e.code === "ArrowUp" && c.value > l) {
        if (c.value === l)
          return;
        c.value--, E.value = !1, e.preventDefault();
      } else if (e.code === "ArrowDown" && c.value < M.value) {
        if (c.value === M.value - 1)
          return;
        c.value++, E.value = !1, e.preventDefault();
      } else
        e.code === "Enter" ? we(e, M.value) : e.code === "Escape" ? (S(), e.preventDefault()) : e.code === "Tab" && setTimeout(() => {
          const o = document.activeElement;
          if (o) {
            const s = o.getAttribute("data-index");
            s !== null && Number.isSafeInteger(+s) && (c.value = +s);
          }
        }, 1);
      se();
    }, De = (e) => p.value[e], we = (e, l) => {
      if (c.value === -1)
        F();
      else {
        const o = c.value;
        if (l > o) {
          let s = De(o);
          t.useGroups && (s = ge(o)), s && O(s, o);
        }
      }
      e.preventDefault();
    }, ge = (e) => {
      let l = null;
      return p.value.forEach((o) => {
        const s = o.totalPreviousItems || 0;
        if (o.items.length + s > e && l === null) {
          const i = e - s;
          l = o.items[i];
        }
      }), l;
    }, ee = (e) => {
      if (f.value) {
        const l = f.value.getElementsByTagName("li")[e];
        if (l && l.className.includes("is-disabled"))
          return !0;
      }
      return !1;
    }, te = (e, l) => {
      const o = ["DropDown__option"];
      return ee(l) && o.push("is-disabled"), e === r.value && o.push("DropDown__option--active"), t.dataText && r.value && e[t.dataText] === r.value[t.dataText] && o.push("DropDown__option--active"), l === c.value && o.push("DropDown__option--arrow-active"), ye(l) && !t.useGroups && o.push("DropDown__option--separator"), o;
    }, L = (e) => P(e, t.dataText, t.textStringFormat), le = (e) => Ve(e, v.value), oe = (e, l = w.SelectedIndex) => {
      O(t.items[e], e, l);
    }, W = (e, l, o = w.SelectedIndex) => {
      let s = 0;
      for (let m = 0; m < p.value.length; m += 1) {
        const i = p.value[m];
        for (let b = 0; b < i.items.length; b += 1) {
          if (s === e) {
            l ? O(i.items[b], e, o) : (r.value = i.items[b], D.value = e);
            return;
          }
          s += 1;
        }
      }
    }, ne = () => {
      for (let e = 0; e < t.items.length; e += 1) {
        const l = t.items[e];
        l.totalPreviousItems = e > 0 ? t.items[e - 1].items.length + t.items[e - 1].totalPreviousItems : 0;
      }
    }, se = () => {
      if (f.value) {
        const e = f.value.querySelector(
          `button[data-index="${c.value}"]`
        );
        if (e) {
          const l = e.parentElement;
          let o = f.value.clientHeight;
          t.allowAutoFilter && (o -= Ye - Ze), G.value && (o -= Xe), l && (o <= l.offsetTop ? f.value.scrollTop = l.offsetTop - o : f.value.scrollTop >= l.offsetTop && (f.value.scrollTop = f.value.scrollTop - l.clientHeight));
        }
      }
    }, ye = (e) => t.separators === void 0 ? !1 : t.separators.indexOf(e) > -1;
    return B(
      () => t.forceReset,
      () => {
        F(!0, !0, w.ForceReset);
      }
    ), B(
      () => t.selectedIndex,
      () => {
        if (isNaN(t.selectedIndex)) {
          console.warn("selectedIndex is not a valid number");
          return;
        }
        t.selectedIndex !== D.value && (t.selectedIndex < 0 ? F(!0, !0, w.SelectedIndex) : M.value > t.selectedIndex ? t.useGroups === !0 ? W(t.selectedIndex, !0) : oe(t.selectedIndex) : console.warn("selectedIndex out of range"));
      }
    ), B(() => t.selectedValue, $), B(
      () => t.items,
      () => {
        F(!1, !1), t.useGroups && ne(), t.selectedValue && $();
      }
    ), t.useGroups && ne(), t.selectedIndex > -1 && (t.selectedIndex > t.items.length && console.warn("selectedIndex out of range"), t.useGroups ? W(t.selectedIndex, !1) : (r.value = t.items[t.selectedIndex], D.value = t.selectedIndex)), t.selectedValue && $(), (e, l) => (h(), re(K(ke), { onTrigger: S }, {
      default: xe(() => [
        x((h(), I("div", {
          class: C(pe.value)
        }, [
          u("button", {
            class: C(ue.value),
            onClick: he
          }, [
            e.title ? (h(), I("div", {
              key: 0,
              class: "DropDown__title",
              innerHTML: e.title
            }, null, 8, Re)) : U("", !0),
            u("div", {
              class: "DropDown__selectedValue",
              innerHTML: L(r.value)
            }, null, 8, Pe)
          ], 2),
          Q.value ? (h(), re(Le, {
            key: 0,
            message: e.validationErrorMessage
          }, null, 8, ["message"])) : U("", !0),
          u("div", {
            class: C(ie.value),
            onClick: S
          }, null, 2),
          x((h(), I("div", {
            class: C(ce.value)
          }, [
            u("button", {
              class: "DropDown__titleMobile",
              innerHTML: e.title,
              "aria-label": "Close",
              onClick: S,
              "data-event": e.$ga.getDataEventValue("dropDown", "button", "close")
            }, null, 8, Ae),
            x(u("div", Ne, [
              x(u("button", {
                class: "DropDown__search__icon DropDown__search__icon--search",
                onClick: X
              }, null, 512), [
                [V, T.value == !1]
              ]),
              x(u("input", {
                class: "DropDown__search__input",
                type: "text",
                disabled: T.value,
                placeholder: e.placeholder,
                "onUpdate:modelValue": l[0] || (l[0] = (o) => v.value = o),
                onFocus: l[1] || (l[1] = (o) => E.value = !0),
                onBlur: l[2] || (l[2] = (o) => E.value = !1),
                onKeyup: Ce(X, ["enter"])
              }, null, 40, $e), [
                [be, v.value]
              ]),
              x(u("div", We, null, 512), [
                [V, T.value]
              ]),
              x(u("div", { class: "DropDown__info" }, j(e.notFoundMessage), 513), [
                [V, fe.value]
              ]),
              x(u("div", { class: "DropDown__error" }, j(k.value), 513), [
                [V, k.value]
              ])
            ], 512), [
              [V, e.allowFilterOptions]
            ]),
            x(u("ul", {
              ref_key: "containerMenu",
              ref: f,
              class: "DropDown__menu"
            }, [
              G.value ? (h(), I("li", {
                key: 0,
                class: C(me.value)
              }, [
                u("button", {
                  class: "DropDown__option__button",
                  onClick: _e,
                  innerHTML: e.emptyOption,
                  "data-index": -1,
                  "data-event": e.$ga.getDataEventValue("dropDown", "btn", "reset")
                }, null, 8, Ke)
              ], 2)) : U("", !0),
              e.useGroups ? (h(!0), I(R, { key: 2 }, q(p.value, (o, s) => (h(), I(R, { key: s }, [
                u("li", je, [
                  qe,
                  u("div", ze, j(o.name), 1),
                  Je
                ]),
                (h(!0), I(R, null, q(o.items, (m, i) => (h(), I("li", {
                  key: `${i}${s}`,
                  class: C(
                    te(m, i + o.totalPreviousItems)
                  )
                }, [
                  u("button", {
                    class: C(["DropDown__option__button", {
                      "DropDown__option__button--filtered": v.value.length
                    }]),
                    onClick: (b) => O(m, i + o.totalPreviousItems),
                    innerHTML: le(L(m)),
                    "data-index": i + o.totalPreviousItems,
                    "data-event": e.$ga.getDataEventValue(
                      "dropDown",
                      ["btn", i.toString()],
                      "click"
                    )
                  }, null, 10, Qe)
                ], 2))), 128))
              ], 64))), 128)) : (h(!0), I(R, { key: 1 }, q(p.value, (o, s) => (h(), I("li", {
                key: s,
                class: C(te(o, s))
              }, [
                u("button", {
                  class: C(["DropDown__option__button", {
                    "DropDown__option__button--filtered": v.value.length
                  }]),
                  onClick: (m) => O(o, s),
                  innerHTML: le(L(o)),
                  "data-index": s,
                  "data-event": e.$ga.getDataEventValue(
                    "dropDown",
                    ["btn", s.toString()],
                    "click"
                  )
                }, null, 10, Ue)
              ], 2))), 128))
            ], 512), [
              [V, de.value]
            ])
          ], 2)), [
            [K(A), g.value]
          ])
        ], 2)), [
          [
            K(_),
            ve.value,
            void 0,
            { noDelay: !0 }
          ]
        ])
      ]),
      _: 1
    }));
  }
});
export {
  He as C,
  w as S,
  at as _,
  Be as a,
  P as g,
  Ve as h
};
